import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import * as ROUTES from '../../../constants/routes';
import PricingPersonaHero from './PricingPersonaHero';
import PricingJourneySection from './PricingJourneySection';

const CARDS = [
    { label: 'Free', amount: '£0', sub: 'free', text: 'Get oriented and see what transaction ready looks like.', cta: { text: 'Get started free', href: ROUTES.REGISTER }, variant: '' },
    { label: 'Lite', amount: '£8.25', sub: '/ mo · £99/yr*', sub2: '*billed annually', text: 'Build your data foundation and start your pre-seed raise.', cta: { text: 'Get started', href: ROUTES.REGISTER }, variant: 'lp-price--lite' },
    { label: 'Pro', amount: '£83.25', sub: '/ mo · £999/yr*', sub2: '*billed annually', text: 'Everything you need to pass Pre-Seed / Seed / Series A due diligence.', cta: { text: 'Get Pro', href: ROUTES.REGISTER }, variant: 'lp-price--pro', badge: 'Most Popular' },
    { label: 'Portfolio Pro', amount: '£66.67', sub: '/ mo · £800/yr* via advisor', sub2: '*billed annually', text: 'All Pro features at a 20% discount, introduced by your advisor.', cta: { text: 'Learn more', href: '#whats-included' }, variant: 'lp-price--dark', badge: '20% off Pro', badgeColor: '#1F8A5B' },
];

// Closing CTA copy per journey stage — the investor framing only fits the Investment tab.
const CTA_COPY = {
    investment: { lead: 'You pitch for Investment', rest: ' — qualified, diligence-backed, more attractive to every investor.' },
    growth: { lead: 'Turbo Boost Your Business', rest: ' and Accelerate Growth & Value' },
    exit: { lead: 'You pitch for Seller', rest: ' — qualified, diligence-backed, more attractive to every buyer.' },
};

const PricingCompaniesPanel = () => {
    const [journey, setJourney] = useState('investment');
    const cta = CTA_COPY[journey] || CTA_COPY.investment;

    return (
    <div role="tabpanel">
        <PricingPersonaHero
            eyebrow="Pricing"
            dotColor="#FC7785"
            title="Simple plans. Built for every stage."
            subtitle="Start free. Upgrade when you're ready to grow, raise or exit."
            primaryCta={{ text: 'Try for free', href: ROUTES.REGISTER }}
            secondaryCta={{ text: 'See what you get ↓', href: '#whats-included' }}
        />

        <section className="lp-pricing-sec" style={{ paddingTop: 0, background: 'transparent' }}>
            <div className="lp-pricing-grid lp-pricing-grid--4">
                {CARDS.map((c, i) => (
                    <div className={`lp-price ${c.variant}`} key={i} data-lp-reveal data-lp-delay={i * 70}>
                        {/* Every badge floats on the card's top edge so it takes no flow space — otherwise the
                            badged card's label and price sit lower than its neighbours'. */}
                        {c.badge && (
                            <div className="lp-price-badge lp-price-badge--center" style={c.badgeColor ? { background: c.badgeColor } : undefined}>{c.badge}</div>
                        )}
                        <div className="lbl" style={{ color: (c.label == 'Pro' || c.label == 'Portfolio Pro') ? '#fff' : '#5b6472' }}>{c.label}</div>
                        <div className={`amt ${c.variant === 'lp-price--lite' ? 'blue' : c.variant === 'lp-price--dark' || c.variant === 'lp-price--pro' ? 'white' : ''}`}>{c.amount}</div>
                        <div className="sub" style={{ marginBottom: '5px' }}>{c.sub}</div>
                        <div className="sub">{c.sub2}</div>
                        <p style={{ flex: 1 }}>{c.text}</p>
                        <a className={`lp-price-btn ${c.variant === 'lp-price--pro' ? 'lp-price-btn--white' : c.variant === 'lp-price--dark' ? 'lp-price-btn--outline' : 'lp-price-btn--dark'}`} href={c.cta.href}>{c.cta.text}</a>
                    </div>
                ))}
            </div>

            <div className="lp-pricing-nudge" data-lp-reveal data-lp-delay="80">
                <span className="emoji">🧭</span>
                <div>
                    <span className="ttl">Need expert guidance?</span>
                    <span className="txt"> We'll match you with an advisor who specialises in your sector — and they'll unlock Portfolio Pro for you too. </span>
                    <a href="#whats-included">AdvisorMatch call →</a>
                </div>
            </div>
        </section>

        <PricingJourneySection active={journey} onChange={setJourney} />

        <section className="lp-cta">
            <div className="lp-cta-card lp-cta-card--emoji" data-lp-reveal>
                <div className="emoji">🤝</div>
                <div className="lp-cta-inner">
                    <h2 style={{ fontSize: 'clamp(20px,2.8vw,28px)' }}><strong>{cta.lead}</strong>{cta.rest}</h2>
                    <Link className="lp-cta-btn" to={ROUTES.REGISTER}>
                        <span>Try for FREE</span>
                        <span className="note">no credit card required</span>
                    </Link>
                    {/* <p className="fine">* Portfolio Pro (£800/yr) available only when introduced by a participating advisor or investor.</p> */}
                </div>
            </div>
        </section>
    </div>
    );
};

export default PricingCompaniesPanel;
